const styles = theme => ({
  backIcon: {
    fontSize: 35,
    marginTop: 6,
    marginLeft: -9,
    [theme.breakpoints.up('sm')]: {
      marginLeft: -9,
    },
    [theme.breakpoints.up('md')]: {
      marginLeft: 2,
    },
  },
});

export default styles;



// WEBPACK FOOTER //
// ./src/scenes/Login/components/ApplicationBar/components/ToolBar/styles.js